const tutorial = () =>
  import(
    /* webpackChunkName: "crm-tutorial" */ '@/pages/crm/tutorial/index.vue'
  )

const CreateTutorial = () =>
  import(
    /* webpackChunkName: "crm-tutorial" */ '@/pages/crm/tutorial/create.vue'
  )

const EditTutorial = () =>
  import(/* webpackChunkName: "crm-tutorial" */ '@/pages/crm/tutorial/edit.vue')

export default {
  path: 'tutorial',
  meta: {
    label: 'tutorial',
    auth: 'tutorial'
  },
  component: {
    name: 'tutorial',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CrmTutorialReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: tutorial
    },
    {
      name: 'CrmCreateTutorial',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateTutorial
    },
    {
      name: 'CrmEditTutorial',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditTutorial,
      props: true
    }
  ]
}
